module.exports = __webpack_public_path__ + "static/img/logo.747d7de8.png";